const getShopName = (id) => id.substring(id.length - 2);

export default getShopName;
